import { Link, useLocation } from 'react-router-dom';
import { useCart } from '@/context/CartContext';

const bottomNavItems = [
  { to: '/', label: 'Home', icon: 'ri-home-5-line', iconActive: 'ri-home-5-fill' },
  { to: '/shop', label: 'Shop', icon: 'ri-store-2-line', iconActive: 'ri-store-2-fill' },
  { to: '/gifting', label: 'Gifting', icon: 'ri-gift-line', iconActive: 'ri-gift-fill' },
  { to: '/cart', label: 'Cart', icon: 'ri-shopping-bag-line', iconActive: 'ri-shopping-bag-fill', isCart: true },
  { to: '/contact', label: 'Contact', icon: 'ri-customer-service-2-line', iconActive: 'ri-customer-service-2-fill' },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const { itemCount, openCart } = useCart();

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/shop') return location.pathname === '/shop';
    return location.pathname === to;
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-t border-background-200/70 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
      <div className="flex items-center justify-around px-2 py-1.5">
        {bottomNavItems.map((item) => {
          const active = isActive(item.to);
          const isCart = item.isCart;

          if (isCart) {
            return (
              <button
                key={item.to}
                onClick={openCart}
                className="relative flex flex-col items-center justify-center gap-0.5 py-1 px-2 min-w-[64px] transition-colors duration-150"
                aria-label={`Cart with ${itemCount} items`}
              >
                <div className="relative w-6 h-6 flex items-center justify-center">
                  <i className={`${active ? item.iconActive : item.icon} text-lg ${active ? 'text-primary-500' : 'text-foreground-400'}`}></i>
                  {itemCount > 0 && (
                    <span className="absolute -top-0.5 -right-1.5 w-4 h-4 flex items-center justify-center bg-accent-500 text-background-50 text-[9px] font-bold rounded-full">
                      {itemCount > 9 ? '9+' : itemCount}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] font-medium ${active ? 'text-primary-500' : 'text-foreground-400'}`}>
                  {item.label}
                </span>
              </button>
            );
          }

          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 py-1 px-2 min-w-[64px] rounded-lg transition-colors duration-150 ${
                active ? 'bg-primary-50' : 'hover:bg-secondary-50'
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${active ? item.iconActive : item.icon} text-lg ${active ? 'text-primary-500' : 'text-foreground-400'}`}></i>
              </div>
              <span className={`text-[10px] font-medium ${active ? 'text-primary-500' : 'text-foreground-400'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
      {/* Safe area padding for notched phones */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}